(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["NISA-Our-Process"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (!window.NisaWorkflowV6) {
  const init = function(section) {
  if (!section) return;
  if (section._nwDestroy) section._nwDestroy();
  const canvas = section.querySelector('.nw-canvas');
  const svg = section.querySelector('.nw-connectors');
  if (!canvas || !svg) return;
  const media = window.matchMedia('(prefers-reduced-motion: reduce)');
  const enabled = section.dataset.nwAnimations !== 'false';
  const seen = new Set();
  let observer, resizeObserver, raf = 0, disposed = false;
  const edges = [
    ['nw-trigger','nw-ai'],
    ['nw-ai','nw-branch-label-left'],['nw-ai','nw-branch-label-right'],
    ['nw-branch-label-left','nw-left-one'],['nw-branch-label-right','nw-right-one'],
    ['nw-left-one','nw-left-two'],['nw-right-one','nw-right-two'],
    ['nw-left-two','nw-final'],['nw-right-two','nw-final'],['nw-final','nw-end-mark']
  ];
  const nodes = new Map();
  edges.flat().forEach(name => nodes.set(name, canvas.querySelector('.' + name)));
  if (Array.from(nodes.values()).some(node => !node)) return;
  const paths = edges.map(([from,to]) => {
    const base = document.createElementNS('http://www.w3.org/2000/svg','path');
    const live = base.cloneNode();
    base.setAttribute('class','nw-path-base');
    live.setAttribute('class','nw-path-live');
    live.setAttribute('pathLength','1');
    svg.append(base,live);
    return {from,to,base,live};
  });
  // Layout coordinates ignore entrance transforms, so lines never drift during reveals.
  function box(node) { return {x:node.offsetLeft + node.offsetWidth / 2, top:node.offsetTop, bottom:node.offsetTop + node.offsetHeight}; }
  function measure() {
    raf = 0;
    if (disposed) return;
    svg.setAttribute('viewBox','0 0 ' + canvas.clientWidth + ' ' + canvas.clientHeight);
    for (const edge of paths) {
      const a=box(nodes.get(edge.from)), b=box(nodes.get(edge.to));
      const mid=(a.bottom+b.top)/2, dx=b.x-a.x;
      const r=Math.max(0, Math.min(16, Math.abs(dx)/2, (b.top-a.bottom)/2));
      const sign=Math.sign(dx);
      const d=Math.abs(dx)<1 ? `M${a.x} ${a.bottom}V${b.top}` :
        `M${a.x} ${a.bottom}V${mid-r}Q${a.x} ${mid} ${a.x+sign*r} ${mid}H${b.x-sign*r}Q${b.x} ${mid} ${b.x} ${mid+r}V${b.top}`;
      edge.base.setAttribute('d',d); edge.live.setAttribute('d',d);
    }
    const badge=canvas.querySelector('.nw-branch-dot');
    const a=box(nodes.get('nw-trigger')), b=box(nodes.get('nw-ai'));
    if (badge) { badge.style.left=a.x+'px'; badge.style.top=((a.bottom+b.top)/2)+'px'; }
  }
  function schedule() { if (!raf && !disposed) raf=requestAnimationFrame(measure); }
  function reveal(node) {
    if (seen.has(node)) return;
    seen.add(node);
    if (enabled && !media.matches && node.classList.contains('nw-card')) node.classList.add('nw-enter');
    paths.filter(edge=>nodes.get(edge.to)===node).forEach(edge=>edge.live.classList.add('is-drawn'));
  }
  function setupMotion() {
    if (observer) observer.disconnect();
    section.classList.toggle('nw-motion',enabled && !media.matches);
    if (!enabled || media.matches || !('IntersectionObserver' in window)) {
      nodes.forEach(reveal); paths.forEach(edge=>edge.live.classList.add('is-drawn')); return;
    }
    observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
      if(entry.isIntersecting) { reveal(entry.target); observer.unobserve(entry.target); }
    }),{threshold:.18});
    nodes.forEach(node=>{if(!seen.has(node)) observer.observe(node);});
  }
  measure(); setupMotion();
  if ('ResizeObserver' in window) { resizeObserver=new ResizeObserver(schedule); resizeObserver.observe(canvas); nodes.forEach(node=>resizeObserver.observe(node)); }
  window.addEventListener('resize',schedule,{passive:true});
  if (document.fonts) document.fonts.ready.then(schedule);
  if (media.addEventListener) media.addEventListener('change',setupMotion);
  else if (media.addListener) media.addListener(setupMotion);
  function unload(event) { if(event.target===section || (event.target.contains && event.target.contains(section))) destroy(); }
  function destroy() {
    disposed=true; cancelAnimationFrame(raf);
    if(observer) observer.disconnect(); if(resizeObserver) resizeObserver.disconnect();
    window.removeEventListener('resize',schedule);
    if (media.removeEventListener) media.removeEventListener('change',setupMotion);
    else if (media.removeListener) media.removeListener(setupMotion);
    document.removeEventListener('shopify:section:unload',unload);
    svg.replaceChildren(); delete section._nwDestroy;
  }
  section._nwDestroy=destroy;
  document.addEventListener('shopify:section:unload',unload);
  };
  window.NisaWorkflowV6 = {init};
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.matches && event.target.matches('.nisa-workflow[data-nw-version="6"]')) init(event.target);
    event.target.querySelectorAll('.nisa-workflow[data-nw-version="6"]').forEach(init);
  });
  }
  document.querySelectorAll('.nisa-workflow[data-nw-version="6"]').forEach(window.NisaWorkflowV6.init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nisa-Cancellation"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  const tag = 'nisa-terms-page';
  if (customElements.get(tag)) return;

  class NisaTermsPage extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (this.isConnected && !this._abort) this.start();
      });
    }

    disconnectedCallback() {
      if (this._abort) this._abort.abort();
      if (this._revealObserver) this._revealObserver.disconnect();
      if (this._frame) cancelAnimationFrame(this._frame);
      if (this._searchTimer) clearTimeout(this._searchTimer);
      if (this._mediaCleanup) this._mediaCleanup();
      this.afterPrint();
      this._abort = null;
      this._frame = 0;
      this.removeAttribute('data-observing');
      this.removeAttribute('data-ready');
    }

    start() {
      this._abort = new AbortController();
      const signal = this._abort.signal;
      this._articles = [...this.querySelectorAll('[data-article]')];
      this._details = [...this.querySelectorAll('[data-policy-details]')];
      this._links = [...this.querySelectorAll('[data-toc-link]')];
      this._search = this.querySelector('[data-search]');
      this._status = this.querySelector('[data-search-status]');
      this._faq = this.querySelector('.ntp__faq');
      this._toc = this.querySelector('[data-toc]');
      this._desktop = matchMedia('(min-width: 990px)');
      this._reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this._initialSearch = null;
      this._printSnapshot = null;
      this._activeId = '';
      this.dataset.ready = 'true';

      const setTocMode = () => {
        if (this._toc) this._toc.open = this._desktop.matches;
        this.schedule();
      };
      setTocMode();
      if (this._desktop.addEventListener) {
        this._desktop.addEventListener('change', setTocMode, { signal });
      } else {
        this._desktop.addListener(setTocMode);
        this._mediaCleanup = () => this._desktop.removeListener(setTocMode);
      }

      this._details.forEach(detail => {
        detail.addEventListener('toggle', () => {
          this.updateExpandLabel();
          this.schedule();
        }, { signal });
      });
      this.addEventListener('click', event => this.onClick(event), { signal });
      if (this._search) {
        this._search.addEventListener('input', () => {
          clearTimeout(this._searchTimer);
          this._searchTimer = setTimeout(() => this.filter(), 120);
        }, { signal });
        this._search.addEventListener('keydown', event => {
          if (event.key === 'Escape') {
            event.preventDefault();
            this.clearSearch();
          }
        }, { signal });
      }

      window.addEventListener('scroll', () => this.schedule(), { passive: true, signal });
      window.addEventListener('resize', () => this.schedule(), { passive: true, signal });
      window.addEventListener('beforeprint', () => this.beforePrint(), { signal });
      window.addEventListener('afterprint', () => this.afterPrint(), { signal });
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const details = event.target.querySelector('details') || event.target.closest('details');
        if (details) details.open = true;
        const article = event.target.closest('[data-article]');
        if (article) {
          this.clearSearch(false);
          article.dataset.visible = 'true';
        }
      }, { signal });

      const reveals = [...this.querySelectorAll('[data-reveal]')];
      if (this.dataset.animate === 'true' && !this._reduceMotion.matches && 'IntersectionObserver' in window) {
        this._revealObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.dataset.visible = 'true';
              this._revealObserver.unobserve(entry.target);
            }
          });
        }, { threshold: 0.02, rootMargin: '0px 0px 70px 0px' });
        reveals.forEach(el => this._revealObserver.observe(el));
        this.dataset.observing = 'true';
      } else {
        reveals.forEach(el => { el.dataset.visible = 'true'; });
      }
      this.updateExpandLabel();
      this.schedule();
      this.openHash();
      window.addEventListener('hashchange', () => this.openHash(), { signal });
    }

    onClick(event) {
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (this._toc && this._desktop.matches && target.closest('[data-toc] > summary')) {
        event.preventDefault();
        return;
      }
      if (target.closest('[data-search-clear], [data-reset-search]')) {
        this.clearSearch();
        return;
      }
      if (target.closest('[data-expand]')) {
        const visible = this._details.filter(detail => !detail.closest('[data-article]').hidden);
        const open = !visible.every(detail => detail.open);
        visible.forEach(detail => { detail.open = open; });
        this.updateExpandLabel();
        this.schedule();
        return;
      }
      if (target.closest('[data-print]')) {
        this.beforePrint();
        try { window.print(); } finally { this.afterPrint(); }
        return;
      }
      const anchor = target.closest('a[href^="#"]');
      if (!anchor || !this.contains(anchor)) return;
      let id;
      try { id = decodeURIComponent(anchor.getAttribute('href').slice(1)); } catch (_) { return; }
      const section = document.getElementById(id);
      if (!section || !this.contains(section)) return;
      event.preventDefault();
      this.navigate(section, true);
    }

    navigate(target, updateHash) {
      const detail = target.querySelector('[data-policy-details]');
      if (target.hidden) this.clearSearch(false);
      if (detail) detail.open = true;
      target.dataset.visible = 'true';
      if (this._toc && !this._desktop.matches) this._toc.open = false;
      if (updateHash) {
        try { history.pushState(null, '', '#' + encodeURIComponent(target.id)); } catch (_) { /* Native anchors remain the fallback. */ }
      }
      target.scrollIntoView({ behavior: this._reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
      const focusTarget = target.querySelector('summary') || target;
      if (!focusTarget.hasAttribute('tabindex') && !focusTarget.matches('summary,a,button,input')) focusTarget.setAttribute('tabindex', '-1');
      focusTarget.focus({ preventScroll: true });
      this.schedule();
    }

    openHash() {
      let id;
      try { id = decodeURIComponent(location.hash.slice(1)); } catch (_) { return; }
      if (!id || !id.startsWith(this.id + '-')) return;
      const target = document.getElementById(id);
      if (target && this.contains(target)) this.navigate(target, false);
    }

    updateExpandLabel() {
      const visible = (this._details || []).filter(detail => !detail.closest('[data-article]').hidden);
      const allOpen = visible.length > 0 && visible.every(detail => detail.open);
      const label = this.querySelector('[data-expand-label]');
      if (label) label.textContent = allOpen ? 'סגירת הכול' : 'פתיחת הכול';
      const button = this.querySelector('[data-expand]');
      if (button) button.disabled = visible.length === 0;
    }

    normalize(text) {
      return text.normalize('NFKD').replace(/[\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7]/g, '').toLocaleLowerCase().replace(/\s+/g, ' ').trim();
    }

    clearMarks() {
      this.querySelectorAll('mark.ntp__match').forEach(mark => {
        const parent = mark.parentNode;
        mark.replaceWith(document.createTextNode(mark.textContent));
        if (parent) parent.normalize();
      });
    }

    highlight(article, query) {
      if (!query || query.length > 100) return;
      const walker = document.createTreeWalker(article.querySelector('[data-search-body]'), NodeFilter.SHOW_TEXT, {
        acceptNode: node => node.parentElement.closest('script,style,button,mark') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT
      });
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      const needle = query.toLocaleLowerCase();
      nodes.forEach(node => {
        const original = node.nodeValue;
        const lower = original.toLocaleLowerCase();
        if (!lower.includes(needle)) return;
        const fragment = document.createDocumentFragment();
        let start = 0;
        let index;
        while ((index = lower.indexOf(needle, start)) !== -1) {
          fragment.append(document.createTextNode(original.slice(start, index)));
          const mark = document.createElement('mark');
          mark.className = 'ntp__match';
          mark.textContent = original.slice(index, index + needle.length);
          fragment.append(mark);
          start = index + needle.length;
        }
        fragment.append(document.createTextNode(original.slice(start)));
        node.replaceWith(fragment);
      });
    }

    filter() {
      if (!this._search) return;
      const raw = this._search.value.trim();
      const query = this.normalize(raw);
      const terms = query.split(' ').filter(Boolean);
      this.clearMarks();
      if (query && !this._initialSearch) this._initialSearch = this._details.map(detail => detail.open);
      let count = 0;
      this._articles.forEach((article, index) => {
        const content = this.normalize(article.textContent);
        const visible = !query || terms.every(term => content.includes(term));
        article.hidden = !visible;
        if (visible) {
          count++;
          if (query) {
            this._details[index].open = true;
            article.dataset.visible = 'true';
            this.highlight(article, raw);
          } else if (this._initialSearch) {
            this._details[index].open = this._initialSearch[index];
          }
        }
        const link = this._links.find(link => link.getAttribute('href') === '#' + article.id);
        if (link) link.hidden = !visible;
      });
      if (!query) this._initialSearch = null;
      const clear = this.querySelector('[data-search-clear]');
      if (clear) clear.hidden = !raw;
      const empty = this.querySelector('[data-no-results]');
      if (empty) empty.hidden = !query || count > 0;
      if (this._status) {
        this._status.hidden = !query;
        this._status.textContent = query ? `${count} מתוך ${this._articles.length} סעיפים מתאימים לחיפוש` : '';
      }
      if (this._faq) this._faq.hidden = Boolean(query);
      const faqLink = this._links.find(link => link.getAttribute('href') === '#' + this.id + '-faq');
      if (faqLink) faqLink.hidden = Boolean(query);
      this.updateExpandLabel();
      this.schedule();
    }

    clearSearch(focus = true) {
      if (!this._search) return;
      clearTimeout(this._searchTimer);
      this._search.value = '';
      this.filter();
      if (focus) this._search.focus({ preventScroll: true });
    }

    schedule() {
      if (this._frame) return;
      this._frame = requestAnimationFrame(() => {
        this._frame = 0;
        if (!this.isConnected) return;
        const offset = Number(this.dataset.offset) || 88;
        const start = this.querySelector('.ntp__document');
        const end = this.querySelector('.ntp__end');
        if (!start || !end) return;
        const startY = start.getBoundingClientRect().top + scrollY;
        const endY = end.getBoundingClientRect().bottom + scrollY;
        const range = Math.max(1, endY - startY - innerHeight + offset);
        const ratio = Math.min(1, Math.max(0, (scrollY + offset - startY) / range));
        this.querySelectorAll('[data-progress-bar],[data-sidebar-progress]').forEach(bar => { bar.style.transform = `scaleX(${ratio})`; });
        const label = this.querySelector('[data-progress-label]');
        if (label) label.textContent = Math.round(ratio * 100) + '%';
        const progress = this.querySelector('.ntp__progress');
        if (progress) progress.toggleAttribute('data-active', this.getBoundingClientRect().top < offset && this.getBoundingClientRect().bottom > offset);
        const targets = [...this._articles, this._faq, this.querySelector('.ntp__contact')].filter(el => el && !el.hidden);
        let current = targets[0];
        targets.forEach(el => { if (el.getBoundingClientRect().top <= offset + 40) current = el; });
        if (current && this._activeId !== current.id) {
          this._activeId = current.id;
          this._links.forEach(link => {
            if (link.getAttribute('href') === '#' + current.id) link.setAttribute('aria-current', 'location');
            else link.removeAttribute('aria-current');
          });
        }
      });
    }

    beforePrint() {
      if (this._printSnapshot) return;
      const details = [...this.querySelectorAll('[data-policy-details],[data-faq-details]')];
      this._printSnapshot = { details, open: details.map(item => item.open), hidden: this._articles.map(item => item.hidden), faqHidden: this._faq ? this._faq.hidden : false };
      details.forEach(item => { item.open = true; });
      this._articles.forEach(item => { item.hidden = false; });
      if (this._faq) this._faq.hidden = false;
    }

    afterPrint() {
      const snapshot = this._printSnapshot;
      if (!snapshot) return;
      snapshot.details.forEach((detail, index) => { detail.open = snapshot.open[index]; });
      this._articles.forEach((item, index) => { item.hidden = snapshot.hidden[index]; });
      if (this._faq) this._faq.hidden = snapshot.faqHidden;
      this._printSnapshot = null;
      this.updateExpandLabel();
      this.schedule();
    }

  }
  customElements.define(tag, NisaTermsPage);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nisa-cancelattion"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  const tag = 'nisa-cancellation-page';
  if (customElements.get(tag)) return;

  class NisaCancellationPage extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (this.isConnected && !this._abort) this.start();
      });
    }

    disconnectedCallback() {
      if (this._abort) this._abort.abort();
      if (this._revealObserver) this._revealObserver.disconnect();
      if (this._frame) cancelAnimationFrame(this._frame);
      if (this._searchTimer) clearTimeout(this._searchTimer);
      if (this._mediaCleanup) this._mediaCleanup();
      this.afterPrint();
      this._abort = null;
      this._frame = 0;
      this.removeAttribute('data-observing');
      this.removeAttribute('data-ready');
    }

    start() {
      this._abort = new AbortController();
      const signal = this._abort.signal;
      this._articles = [...this.querySelectorAll('[data-article]')];
      this._details = [...this.querySelectorAll('[data-policy-details]')];
      this._links = [...this.querySelectorAll('[data-toc-link]')];
      this._search = this.querySelector('[data-search]');
      this._status = this.querySelector('[data-search-status]');
      this._faq = this.querySelector('.ncp__faq');
      this._toc = this.querySelector('[data-toc]');
      this._desktop = matchMedia('(min-width: 990px)');
      this._reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this._initialSearch = null;
      this._printSnapshot = null;
      this._activeId = '';
      this.dataset.ready = 'true';

      const setTocMode = () => {
        if (this._toc) this._toc.open = this._desktop.matches;
        this.schedule();
      };
      setTocMode();
      if (this._desktop.addEventListener) {
        this._desktop.addEventListener('change', setTocMode, { signal });
      } else {
        this._desktop.addListener(setTocMode);
        this._mediaCleanup = () => this._desktop.removeListener(setTocMode);
      }

      this._details.forEach(detail => {
        detail.addEventListener('toggle', () => {
          this.updateExpandLabel();
          this.schedule();
        }, { signal });
      });
      this.addEventListener('click', event => this.onClick(event), { signal });
      if (this._search) {
        this._search.addEventListener('input', () => {
          clearTimeout(this._searchTimer);
          this._searchTimer = setTimeout(() => this.filter(), 120);
        }, { signal });
        this._search.addEventListener('keydown', event => {
          if (event.key === 'Escape') {
            event.preventDefault();
            this.clearSearch();
          }
        }, { signal });
      }

      window.addEventListener('scroll', () => this.schedule(), { passive: true, signal });
      window.addEventListener('resize', () => this.schedule(), { passive: true, signal });
      window.addEventListener('beforeprint', () => this.beforePrint(), { signal });
      window.addEventListener('afterprint', () => this.afterPrint(), { signal });
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const details = event.target.querySelector('details') || event.target.closest('details');
        if (details) details.open = true;
        const article = event.target.closest('[data-article]');
        if (article) {
          this.clearSearch(false);
          article.dataset.visible = 'true';
        }
      }, { signal });

      const reveals = [...this.querySelectorAll('[data-reveal]')];
      if (this.dataset.animate === 'true' && !this._reduceMotion.matches && 'IntersectionObserver' in window) {
        this._revealObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.dataset.visible = 'true';
              this._revealObserver.unobserve(entry.target);
            }
          });
        }, { threshold: 0.02, rootMargin: '0px 0px 70px 0px' });
        reveals.forEach(el => this._revealObserver.observe(el));
        this.dataset.observing = 'true';
      } else {
        reveals.forEach(el => { el.dataset.visible = 'true'; });
      }
      this.updateExpandLabel();
      this.schedule();
      this.openHash();
      window.addEventListener('hashchange', () => this.openHash(), { signal });
    }

    onClick(event) {
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (this._toc && this._desktop.matches && target.closest('[data-toc] > summary')) {
        event.preventDefault();
        return;
      }
      if (target.closest('[data-search-clear], [data-reset-search]')) {
        this.clearSearch();
        return;
      }
      if (target.closest('[data-expand]')) {
        const visible = this._details.filter(detail => !detail.closest('[data-article]').hidden);
        const open = !visible.every(detail => detail.open);
        visible.forEach(detail => { detail.open = open; });
        this.updateExpandLabel();
        this.schedule();
        return;
      }
      if (target.closest('[data-print]')) {
        this.beforePrint();
        try { window.print(); } finally { this.afterPrint(); }
        return;
      }
      const anchor = target.closest('a[href^="#"]');
      if (!anchor || !this.contains(anchor)) return;
      let id;
      try { id = decodeURIComponent(anchor.getAttribute('href').slice(1)); } catch (_) { return; }
      const section = document.getElementById(id);
      if (!section || !this.contains(section)) return;
      event.preventDefault();
      this.navigate(section, true);
    }

    navigate(target, updateHash) {
      const detail = target.querySelector('[data-policy-details]');
      if (target.hidden) this.clearSearch(false);
      if (detail) detail.open = true;
      target.dataset.visible = 'true';
      if (this._toc && !this._desktop.matches) this._toc.open = false;
      if (updateHash) {
        try { history.pushState(null, '', '#' + encodeURIComponent(target.id)); } catch (_) { /* Native anchors remain the fallback. */ }
      }
      target.scrollIntoView({ behavior: this._reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
      const focusTarget = target.querySelector('summary') || target;
      if (!focusTarget.hasAttribute('tabindex') && !focusTarget.matches('summary,a,button,input')) focusTarget.setAttribute('tabindex', '-1');
      focusTarget.focus({ preventScroll: true });
      this.schedule();
    }

    openHash() {
      let id;
      try { id = decodeURIComponent(location.hash.slice(1)); } catch (_) { return; }
      if (!id || !id.startsWith(this.id + '-')) return;
      const target = document.getElementById(id);
      if (target && this.contains(target)) this.navigate(target, false);
    }

    updateExpandLabel() {
      const visible = (this._details || []).filter(detail => !detail.closest('[data-article]').hidden);
      const allOpen = visible.length > 0 && visible.every(detail => detail.open);
      const label = this.querySelector('[data-expand-label]');
      if (label) label.textContent = allOpen ? 'סגירת הכול' : 'פתיחת הכול';
      const button = this.querySelector('[data-expand]');
      if (button) button.disabled = visible.length === 0;
    }

    normalize(text) {
      return text.normalize('NFKD').replace(/[\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7]/g, '').toLocaleLowerCase().replace(/\s+/g, ' ').trim();
    }

    clearMarks() {
      this.querySelectorAll('mark.ncp__match').forEach(mark => {
        const parent = mark.parentNode;
        mark.replaceWith(document.createTextNode(mark.textContent));
        if (parent) parent.normalize();
      });
    }

    highlight(article, query) {
      if (!query || query.length > 100) return;
      const walker = document.createTreeWalker(article.querySelector('[data-search-body]'), NodeFilter.SHOW_TEXT, {
        acceptNode: node => node.parentElement.closest('script,style,button,mark') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT
      });
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      const needle = query.toLocaleLowerCase();
      nodes.forEach(node => {
        const original = node.nodeValue;
        const lower = original.toLocaleLowerCase();
        if (!lower.includes(needle)) return;
        const fragment = document.createDocumentFragment();
        let start = 0;
        let index;
        while ((index = lower.indexOf(needle, start)) !== -1) {
          fragment.append(document.createTextNode(original.slice(start, index)));
          const mark = document.createElement('mark');
          mark.className = 'ncp__match';
          mark.textContent = original.slice(index, index + needle.length);
          fragment.append(mark);
          start = index + needle.length;
        }
        fragment.append(document.createTextNode(original.slice(start)));
        node.replaceWith(fragment);
      });
    }

    filter() {
      if (!this._search) return;
      const raw = this._search.value.trim();
      const query = this.normalize(raw);
      const terms = query.split(' ').filter(Boolean);
      this.clearMarks();
      if (query && !this._initialSearch) this._initialSearch = this._details.map(detail => detail.open);
      let count = 0;
      this._articles.forEach((article, index) => {
        const content = this.normalize(article.textContent);
        const visible = !query || terms.every(term => content.includes(term));
        article.hidden = !visible;
        if (visible) {
          count++;
          if (query) {
            this._details[index].open = true;
            article.dataset.visible = 'true';
            this.highlight(article, raw);
          } else if (this._initialSearch) {
            this._details[index].open = this._initialSearch[index];
          }
        }
        const link = this._links.find(link => link.getAttribute('href') === '#' + article.id);
        if (link) link.hidden = !visible;
      });
      if (!query) this._initialSearch = null;
      const clear = this.querySelector('[data-search-clear]');
      if (clear) clear.hidden = !raw;
      const empty = this.querySelector('[data-no-results]');
      if (empty) empty.hidden = !query || count > 0;
      if (this._status) {
        this._status.hidden = !query;
        this._status.textContent = query ? `${count} מתוך ${this._articles.length} סעיפים מתאימים לחיפוש` : '';
      }
      if (this._faq) this._faq.hidden = Boolean(query);
      const faqLink = this._links.find(link => link.getAttribute('href') === '#' + this.id + '-faq');
      if (faqLink) faqLink.hidden = Boolean(query);
      this.updateExpandLabel();
      this.schedule();
    }

    clearSearch(focus = true) {
      if (!this._search) return;
      clearTimeout(this._searchTimer);
      this._search.value = '';
      this.filter();
      if (focus) this._search.focus({ preventScroll: true });
    }

    schedule() {
      if (this._frame) return;
      this._frame = requestAnimationFrame(() => {
        this._frame = 0;
        if (!this.isConnected) return;
        const offset = Number(this.dataset.offset) || 88;
        const start = this.querySelector('.ncp__document');
        const end = this.querySelector('.ncp__end');
        if (!start || !end) return;
        const startY = start.getBoundingClientRect().top + scrollY;
        const endY = end.getBoundingClientRect().bottom + scrollY;
        const range = Math.max(1, endY - startY - innerHeight + offset);
        const ratio = Math.min(1, Math.max(0, (scrollY + offset - startY) / range));
        this.querySelectorAll('[data-progress-bar],[data-sidebar-progress]').forEach(bar => { bar.style.transform = `scaleX(${ratio})`; });
        const label = this.querySelector('[data-progress-label]');
        if (label) label.textContent = Math.round(ratio * 100) + '%';
        const progress = this.querySelector('.ncp__progress');
        if (progress) progress.toggleAttribute('data-active', this.getBoundingClientRect().top < offset && this.getBoundingClientRect().bottom > offset);
        const targets = [...this._articles, this._faq, this.querySelector('.ncp__contact')].filter(el => el && !el.hidden);
        let current = targets[0];
        targets.forEach(el => { if (el.getBoundingClientRect().top <= offset + 40) current = el; });
        if (current && this._activeId !== current.id) {
          this._activeId = current.id;
          this._links.forEach(link => {
            if (link.getAttribute('href') === '#' + current.id) link.setAttribute('aria-current', 'location');
            else link.removeAttribute('aria-current');
          });
        }
      });
    }

    beforePrint() {
      if (this._printSnapshot) return;
      const details = [...this.querySelectorAll('[data-policy-details],[data-faq-details]')];
      this._printSnapshot = { details, open: details.map(item => item.open), hidden: this._articles.map(item => item.hidden), faqHidden: this._faq ? this._faq.hidden : false };
      details.forEach(item => { item.open = true; });
      this._articles.forEach(item => { item.hidden = false; });
      if (this._faq) this._faq.hidden = false;
    }

    afterPrint() {
      const snapshot = this._printSnapshot;
      if (!snapshot) return;
      snapshot.details.forEach((detail, index) => { detail.open = snapshot.open[index]; });
      this._articles.forEach((item, index) => { item.hidden = snapshot.hidden[index]; });
      if (this._faq) this._faq.hidden = snapshot.faqHidden;
      this._printSnapshot = null;
      this.updateExpandLabel();
      this.schedule();
    }

  }
  customElements.define(tag, NisaCancellationPage);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nisa-privacy-policy"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  const tag = 'nisa-terms-page';
  if (customElements.get(tag)) return;

  class NisaTermsPage extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (this.isConnected && !this._abort) this.start();
      });
    }

    disconnectedCallback() {
      if (this._abort) this._abort.abort();
      if (this._revealObserver) this._revealObserver.disconnect();
      if (this._frame) cancelAnimationFrame(this._frame);
      if (this._searchTimer) clearTimeout(this._searchTimer);
      if (this._mediaCleanup) this._mediaCleanup();
      this.afterPrint();
      this._abort = null;
      this._frame = 0;
      this.removeAttribute('data-observing');
      this.removeAttribute('data-ready');
    }

    start() {
      this._abort = new AbortController();
      const signal = this._abort.signal;
      this._articles = [...this.querySelectorAll('[data-article]')];
      this._details = [...this.querySelectorAll('[data-policy-details]')];
      this._links = [...this.querySelectorAll('[data-toc-link]')];
      this._search = this.querySelector('[data-search]');
      this._status = this.querySelector('[data-search-status]');
      this._faq = this.querySelector('.ntp__faq');
      this._toc = this.querySelector('[data-toc]');
      this._desktop = matchMedia('(min-width: 990px)');
      this._reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this._initialSearch = null;
      this._printSnapshot = null;
      this._activeId = '';
      this.dataset.ready = 'true';

      const setTocMode = () => {
        if (this._toc) this._toc.open = this._desktop.matches;
        this.schedule();
      };
      setTocMode();
      if (this._desktop.addEventListener) {
        this._desktop.addEventListener('change', setTocMode, { signal });
      } else {
        this._desktop.addListener(setTocMode);
        this._mediaCleanup = () => this._desktop.removeListener(setTocMode);
      }

      this._details.forEach(detail => {
        detail.addEventListener('toggle', () => {
          this.updateExpandLabel();
          this.schedule();
        }, { signal });
      });
      this.addEventListener('click', event => this.onClick(event), { signal });
      if (this._search) {
        this._search.addEventListener('input', () => {
          clearTimeout(this._searchTimer);
          this._searchTimer = setTimeout(() => this.filter(), 120);
        }, { signal });
        this._search.addEventListener('keydown', event => {
          if (event.key === 'Escape') {
            event.preventDefault();
            this.clearSearch();
          }
        }, { signal });
      }

      window.addEventListener('scroll', () => this.schedule(), { passive: true, signal });
      window.addEventListener('resize', () => this.schedule(), { passive: true, signal });
      window.addEventListener('beforeprint', () => this.beforePrint(), { signal });
      window.addEventListener('afterprint', () => this.afterPrint(), { signal });
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const details = event.target.querySelector('details') || event.target.closest('details');
        if (details) details.open = true;
        const article = event.target.closest('[data-article]');
        if (article) {
          this.clearSearch(false);
          article.dataset.visible = 'true';
        }
      }, { signal });

      const reveals = [...this.querySelectorAll('[data-reveal]')];
      if (this.dataset.animate === 'true' && !this._reduceMotion.matches && 'IntersectionObserver' in window) {
        this._revealObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.dataset.visible = 'true';
              this._revealObserver.unobserve(entry.target);
            }
          });
        }, { threshold: 0.02, rootMargin: '0px 0px 70px 0px' });
        reveals.forEach(el => this._revealObserver.observe(el));
        this.dataset.observing = 'true';
      } else {
        reveals.forEach(el => { el.dataset.visible = 'true'; });
      }
      this.updateExpandLabel();
      this.schedule();
      this.openHash();
      window.addEventListener('hashchange', () => this.openHash(), { signal });
    }

    onClick(event) {
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (this._toc && this._desktop.matches && target.closest('[data-toc] > summary')) {
        event.preventDefault();
        return;
      }
      if (target.closest('[data-search-clear], [data-reset-search]')) {
        this.clearSearch();
        return;
      }
      if (target.closest('[data-expand]')) {
        const visible = this._details.filter(detail => !detail.closest('[data-article]').hidden);
        const open = !visible.every(detail => detail.open);
        visible.forEach(detail => { detail.open = open; });
        this.updateExpandLabel();
        this.schedule();
        return;
      }
      if (target.closest('[data-print]')) {
        this.beforePrint();
        try { window.print(); } finally { this.afterPrint(); }
        return;
      }
      const anchor = target.closest('a[href^="#"]');
      if (!anchor || !this.contains(anchor)) return;
      let id;
      try { id = decodeURIComponent(anchor.getAttribute('href').slice(1)); } catch (_) { return; }
      const section = document.getElementById(id);
      if (!section || !this.contains(section)) return;
      event.preventDefault();
      this.navigate(section, true);
    }

    navigate(target, updateHash) {
      const detail = target.querySelector('[data-policy-details]');
      if (target.hidden) this.clearSearch(false);
      if (detail) detail.open = true;
      target.dataset.visible = 'true';
      if (this._toc && !this._desktop.matches) this._toc.open = false;
      if (updateHash) {
        try { history.pushState(null, '', '#' + encodeURIComponent(target.id)); } catch (_) { /* Native anchors remain the fallback. */ }
      }
      target.scrollIntoView({ behavior: this._reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
      const focusTarget = target.querySelector('summary') || target;
      if (!focusTarget.hasAttribute('tabindex') && !focusTarget.matches('summary,a,button,input')) focusTarget.setAttribute('tabindex', '-1');
      focusTarget.focus({ preventScroll: true });
      this.schedule();
    }

    openHash() {
      let id;
      try { id = decodeURIComponent(location.hash.slice(1)); } catch (_) { return; }
      if (!id || !id.startsWith(this.id + '-')) return;
      const target = document.getElementById(id);
      if (target && this.contains(target)) this.navigate(target, false);
    }

    updateExpandLabel() {
      const visible = (this._details || []).filter(detail => !detail.closest('[data-article]').hidden);
      const allOpen = visible.length > 0 && visible.every(detail => detail.open);
      const label = this.querySelector('[data-expand-label]');
      if (label) label.textContent = allOpen ? 'סגירת הכול' : 'פתיחת הכול';
      const button = this.querySelector('[data-expand]');
      if (button) button.disabled = visible.length === 0;
    }

    normalize(text) {
      return text.normalize('NFKD').replace(/[\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7]/g, '').toLocaleLowerCase().replace(/\s+/g, ' ').trim();
    }

    clearMarks() {
      this.querySelectorAll('mark.ntp__match').forEach(mark => {
        const parent = mark.parentNode;
        mark.replaceWith(document.createTextNode(mark.textContent));
        if (parent) parent.normalize();
      });
    }

    highlight(article, query) {
      if (!query || query.length > 100) return;
      const walker = document.createTreeWalker(article.querySelector('[data-search-body]'), NodeFilter.SHOW_TEXT, {
        acceptNode: node => node.parentElement.closest('script,style,button,mark') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT
      });
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      const needle = query.toLocaleLowerCase();
      nodes.forEach(node => {
        const original = node.nodeValue;
        const lower = original.toLocaleLowerCase();
        if (!lower.includes(needle)) return;
        const fragment = document.createDocumentFragment();
        let start = 0;
        let index;
        while ((index = lower.indexOf(needle, start)) !== -1) {
          fragment.append(document.createTextNode(original.slice(start, index)));
          const mark = document.createElement('mark');
          mark.className = 'ntp__match';
          mark.textContent = original.slice(index, index + needle.length);
          fragment.append(mark);
          start = index + needle.length;
        }
        fragment.append(document.createTextNode(original.slice(start)));
        node.replaceWith(fragment);
      });
    }

    filter() {
      if (!this._search) return;
      const raw = this._search.value.trim();
      const query = this.normalize(raw);
      const terms = query.split(' ').filter(Boolean);
      this.clearMarks();
      if (query && !this._initialSearch) this._initialSearch = this._details.map(detail => detail.open);
      let count = 0;
      this._articles.forEach((article, index) => {
        const content = this.normalize(article.textContent);
        const visible = !query || terms.every(term => content.includes(term));
        article.hidden = !visible;
        if (visible) {
          count++;
          if (query) {
            this._details[index].open = true;
            article.dataset.visible = 'true';
            this.highlight(article, raw);
          } else if (this._initialSearch) {
            this._details[index].open = this._initialSearch[index];
          }
        }
        const link = this._links.find(link => link.getAttribute('href') === '#' + article.id);
        if (link) link.hidden = !visible;
      });
      if (!query) this._initialSearch = null;
      const clear = this.querySelector('[data-search-clear]');
      if (clear) clear.hidden = !raw;
      const empty = this.querySelector('[data-no-results]');
      if (empty) empty.hidden = !query || count > 0;
      if (this._status) {
        this._status.hidden = !query;
        this._status.textContent = query ? `${count} מתוך ${this._articles.length} סעיפים מתאימים לחיפוש` : '';
      }
      if (this._faq) this._faq.hidden = Boolean(query);
      const faqLink = this._links.find(link => link.getAttribute('href') === '#' + this.id + '-faq');
      if (faqLink) faqLink.hidden = Boolean(query);
      this.updateExpandLabel();
      this.schedule();
    }

    clearSearch(focus = true) {
      if (!this._search) return;
      clearTimeout(this._searchTimer);
      this._search.value = '';
      this.filter();
      if (focus) this._search.focus({ preventScroll: true });
    }

    schedule() {
      if (this._frame) return;
      this._frame = requestAnimationFrame(() => {
        this._frame = 0;
        if (!this.isConnected) return;
        const offset = Number(this.dataset.offset) || 88;
        const start = this.querySelector('.ntp__document');
        const end = this.querySelector('.ntp__end');
        if (!start || !end) return;
        const startY = start.getBoundingClientRect().top + scrollY;
        const endY = end.getBoundingClientRect().bottom + scrollY;
        const range = Math.max(1, endY - startY - innerHeight + offset);
        const ratio = Math.min(1, Math.max(0, (scrollY + offset - startY) / range));
        this.querySelectorAll('[data-progress-bar],[data-sidebar-progress]').forEach(bar => { bar.style.transform = `scaleX(${ratio})`; });
        const label = this.querySelector('[data-progress-label]');
        if (label) label.textContent = Math.round(ratio * 100) + '%';
        const progress = this.querySelector('.ntp__progress');
        if (progress) progress.toggleAttribute('data-active', this.getBoundingClientRect().top < offset && this.getBoundingClientRect().bottom > offset);
        const targets = [...this._articles, this._faq, this.querySelector('.ntp__contact')].filter(el => el && !el.hidden);
        let current = targets[0];
        targets.forEach(el => { if (el.getBoundingClientRect().top <= offset + 40) current = el; });
        if (current && this._activeId !== current.id) {
          this._activeId = current.id;
          this._links.forEach(link => {
            if (link.getAttribute('href') === '#' + current.id) link.setAttribute('aria-current', 'location');
            else link.removeAttribute('aria-current');
          });
        }
      });
    }

    beforePrint() {
      if (this._printSnapshot) return;
      const details = [...this.querySelectorAll('[data-policy-details],[data-faq-details]')];
      this._printSnapshot = { details, open: details.map(item => item.open), hidden: this._articles.map(item => item.hidden), faqHidden: this._faq ? this._faq.hidden : false };
      details.forEach(item => { item.open = true; });
      this._articles.forEach(item => { item.hidden = false; });
      if (this._faq) this._faq.hidden = false;
    }

    afterPrint() {
      const snapshot = this._printSnapshot;
      if (!snapshot) return;
      snapshot.details.forEach((detail, index) => { detail.open = snapshot.open[index]; });
      this._articles.forEach((item, index) => { item.hidden = snapshot.hidden[index]; });
      if (this._faq) this._faq.hidden = snapshot.faqHidden;
      this._printSnapshot = null;
      this.updateExpandLabel();
      this.schedule();
    }

  }
  customElements.define(tag, NisaTermsPage);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nisa-terms"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  const tag = 'nisa-terms-page';
  if (customElements.get(tag)) return;

  class NisaTermsPage extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (this.isConnected && !this._abort) this.start();
      });
    }

    disconnectedCallback() {
      if (this._abort) this._abort.abort();
      if (this._revealObserver) this._revealObserver.disconnect();
      if (this._frame) cancelAnimationFrame(this._frame);
      if (this._searchTimer) clearTimeout(this._searchTimer);
      if (this._mediaCleanup) this._mediaCleanup();
      this.afterPrint();
      this._abort = null;
      this._frame = 0;
      this.removeAttribute('data-observing');
      this.removeAttribute('data-ready');
    }

    start() {
      this._abort = new AbortController();
      const signal = this._abort.signal;
      this._articles = [...this.querySelectorAll('[data-article]')];
      this._details = [...this.querySelectorAll('[data-policy-details]')];
      this._links = [...this.querySelectorAll('[data-toc-link]')];
      this._search = this.querySelector('[data-search]');
      this._status = this.querySelector('[data-search-status]');
      this._faq = this.querySelector('.ntp__faq');
      this._toc = this.querySelector('[data-toc]');
      this._desktop = matchMedia('(min-width: 990px)');
      this._reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this._initialSearch = null;
      this._printSnapshot = null;
      this._activeId = '';
      this.dataset.ready = 'true';

      const setTocMode = () => {
        if (this._toc) this._toc.open = this._desktop.matches;
        this.schedule();
      };
      setTocMode();
      if (this._desktop.addEventListener) {
        this._desktop.addEventListener('change', setTocMode, { signal });
      } else {
        this._desktop.addListener(setTocMode);
        this._mediaCleanup = () => this._desktop.removeListener(setTocMode);
      }

      this._details.forEach(detail => {
        detail.addEventListener('toggle', () => {
          this.updateExpandLabel();
          this.schedule();
        }, { signal });
      });
      this.addEventListener('click', event => this.onClick(event), { signal });
      if (this._search) {
        this._search.addEventListener('input', () => {
          clearTimeout(this._searchTimer);
          this._searchTimer = setTimeout(() => this.filter(), 120);
        }, { signal });
        this._search.addEventListener('keydown', event => {
          if (event.key === 'Escape') {
            event.preventDefault();
            this.clearSearch();
          }
        }, { signal });
      }

      window.addEventListener('scroll', () => this.schedule(), { passive: true, signal });
      window.addEventListener('resize', () => this.schedule(), { passive: true, signal });
      window.addEventListener('beforeprint', () => this.beforePrint(), { signal });
      window.addEventListener('afterprint', () => this.afterPrint(), { signal });
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const details = event.target.querySelector('details') || event.target.closest('details');
        if (details) details.open = true;
        const article = event.target.closest('[data-article]');
        if (article) {
          this.clearSearch(false);
          article.dataset.visible = 'true';
        }
      }, { signal });

      const reveals = [...this.querySelectorAll('[data-reveal]')];
      if (this.dataset.animate === 'true' && !this._reduceMotion.matches && 'IntersectionObserver' in window) {
        this._revealObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.dataset.visible = 'true';
              this._revealObserver.unobserve(entry.target);
            }
          });
        }, { threshold: 0.02, rootMargin: '0px 0px 70px 0px' });
        reveals.forEach(el => this._revealObserver.observe(el));
        this.dataset.observing = 'true';
      } else {
        reveals.forEach(el => { el.dataset.visible = 'true'; });
      }
      this.updateExpandLabel();
      this.schedule();
      this.openHash();
      window.addEventListener('hashchange', () => this.openHash(), { signal });
    }

    onClick(event) {
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (this._toc && this._desktop.matches && target.closest('[data-toc] > summary')) {
        event.preventDefault();
        return;
      }
      if (target.closest('[data-search-clear], [data-reset-search]')) {
        this.clearSearch();
        return;
      }
      if (target.closest('[data-expand]')) {
        const visible = this._details.filter(detail => !detail.closest('[data-article]').hidden);
        const open = !visible.every(detail => detail.open);
        visible.forEach(detail => { detail.open = open; });
        this.updateExpandLabel();
        this.schedule();
        return;
      }
      if (target.closest('[data-print]')) {
        this.beforePrint();
        try { window.print(); } finally { this.afterPrint(); }
        return;
      }
      const anchor = target.closest('a[href^="#"]');
      if (!anchor || !this.contains(anchor)) return;
      let id;
      try { id = decodeURIComponent(anchor.getAttribute('href').slice(1)); } catch (_) { return; }
      const section = document.getElementById(id);
      if (!section || !this.contains(section)) return;
      event.preventDefault();
      this.navigate(section, true);
    }

    navigate(target, updateHash) {
      const detail = target.querySelector('[data-policy-details]');
      if (target.hidden) this.clearSearch(false);
      if (detail) detail.open = true;
      target.dataset.visible = 'true';
      if (this._toc && !this._desktop.matches) this._toc.open = false;
      if (updateHash) {
        try { history.pushState(null, '', '#' + encodeURIComponent(target.id)); } catch (_) { /* Native anchors remain the fallback. */ }
      }
      target.scrollIntoView({ behavior: this._reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
      const focusTarget = target.querySelector('summary') || target;
      if (!focusTarget.hasAttribute('tabindex') && !focusTarget.matches('summary,a,button,input')) focusTarget.setAttribute('tabindex', '-1');
      focusTarget.focus({ preventScroll: true });
      this.schedule();
    }

    openHash() {
      let id;
      try { id = decodeURIComponent(location.hash.slice(1)); } catch (_) { return; }
      if (!id || !id.startsWith(this.id + '-')) return;
      const target = document.getElementById(id);
      if (target && this.contains(target)) this.navigate(target, false);
    }

    updateExpandLabel() {
      const visible = (this._details || []).filter(detail => !detail.closest('[data-article]').hidden);
      const allOpen = visible.length > 0 && visible.every(detail => detail.open);
      const label = this.querySelector('[data-expand-label]');
      if (label) label.textContent = allOpen ? 'סגירת הכול' : 'פתיחת הכול';
      const button = this.querySelector('[data-expand]');
      if (button) button.disabled = visible.length === 0;
    }

    normalize(text) {
      return text.normalize('NFKD').replace(/[\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7]/g, '').toLocaleLowerCase().replace(/\s+/g, ' ').trim();
    }

    clearMarks() {
      this.querySelectorAll('mark.ntp__match').forEach(mark => {
        const parent = mark.parentNode;
        mark.replaceWith(document.createTextNode(mark.textContent));
        if (parent) parent.normalize();
      });
    }

    highlight(article, query) {
      if (!query || query.length > 100) return;
      const walker = document.createTreeWalker(article.querySelector('[data-search-body]'), NodeFilter.SHOW_TEXT, {
        acceptNode: node => node.parentElement.closest('script,style,button,mark') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT
      });
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      const needle = query.toLocaleLowerCase();
      nodes.forEach(node => {
        const original = node.nodeValue;
        const lower = original.toLocaleLowerCase();
        if (!lower.includes(needle)) return;
        const fragment = document.createDocumentFragment();
        let start = 0;
        let index;
        while ((index = lower.indexOf(needle, start)) !== -1) {
          fragment.append(document.createTextNode(original.slice(start, index)));
          const mark = document.createElement('mark');
          mark.className = 'ntp__match';
          mark.textContent = original.slice(index, index + needle.length);
          fragment.append(mark);
          start = index + needle.length;
        }
        fragment.append(document.createTextNode(original.slice(start)));
        node.replaceWith(fragment);
      });
    }

    filter() {
      if (!this._search) return;
      const raw = this._search.value.trim();
      const query = this.normalize(raw);
      const terms = query.split(' ').filter(Boolean);
      this.clearMarks();
      if (query && !this._initialSearch) this._initialSearch = this._details.map(detail => detail.open);
      let count = 0;
      this._articles.forEach((article, index) => {
        const content = this.normalize(article.textContent);
        const visible = !query || terms.every(term => content.includes(term));
        article.hidden = !visible;
        if (visible) {
          count++;
          if (query) {
            this._details[index].open = true;
            article.dataset.visible = 'true';
            this.highlight(article, raw);
          } else if (this._initialSearch) {
            this._details[index].open = this._initialSearch[index];
          }
        }
        const link = this._links.find(link => link.getAttribute('href') === '#' + article.id);
        if (link) link.hidden = !visible;
      });
      if (!query) this._initialSearch = null;
      const clear = this.querySelector('[data-search-clear]');
      if (clear) clear.hidden = !raw;
      const empty = this.querySelector('[data-no-results]');
      if (empty) empty.hidden = !query || count > 0;
      if (this._status) {
        this._status.hidden = !query;
        this._status.textContent = query ? `${count} מתוך ${this._articles.length} סעיפים מתאימים לחיפוש` : '';
      }
      if (this._faq) this._faq.hidden = Boolean(query);
      const faqLink = this._links.find(link => link.getAttribute('href') === '#' + this.id + '-faq');
      if (faqLink) faqLink.hidden = Boolean(query);
      this.updateExpandLabel();
      this.schedule();
    }

    clearSearch(focus = true) {
      if (!this._search) return;
      clearTimeout(this._searchTimer);
      this._search.value = '';
      this.filter();
      if (focus) this._search.focus({ preventScroll: true });
    }

    schedule() {
      if (this._frame) return;
      this._frame = requestAnimationFrame(() => {
        this._frame = 0;
        if (!this.isConnected) return;
        const offset = Number(this.dataset.offset) || 88;
        const start = this.querySelector('.ntp__document');
        const end = this.querySelector('.ntp__end');
        if (!start || !end) return;
        const startY = start.getBoundingClientRect().top + scrollY;
        const endY = end.getBoundingClientRect().bottom + scrollY;
        const range = Math.max(1, endY - startY - innerHeight + offset);
        const ratio = Math.min(1, Math.max(0, (scrollY + offset - startY) / range));
        this.querySelectorAll('[data-progress-bar],[data-sidebar-progress]').forEach(bar => { bar.style.transform = `scaleX(${ratio})`; });
        const label = this.querySelector('[data-progress-label]');
        if (label) label.textContent = Math.round(ratio * 100) + '%';
        const progress = this.querySelector('.ntp__progress');
        if (progress) progress.toggleAttribute('data-active', this.getBoundingClientRect().top < offset && this.getBoundingClientRect().bottom > offset);
        const targets = [...this._articles, this._faq, this.querySelector('.ntp__contact')].filter(el => el && !el.hidden);
        let current = targets[0];
        targets.forEach(el => { if (el.getBoundingClientRect().top <= offset + 40) current = el; });
        if (current && this._activeId !== current.id) {
          this._activeId = current.id;
          this._links.forEach(link => {
            if (link.getAttribute('href') === '#' + current.id) link.setAttribute('aria-current', 'location');
            else link.removeAttribute('aria-current');
          });
        }
      });
    }

    beforePrint() {
      if (this._printSnapshot) return;
      const details = [...this.querySelectorAll('[data-policy-details],[data-faq-details]')];
      this._printSnapshot = { details, open: details.map(item => item.open), hidden: this._articles.map(item => item.hidden), faqHidden: this._faq ? this._faq.hidden : false };
      details.forEach(item => { item.open = true; });
      this._articles.forEach(item => { item.hidden = false; });
      if (this._faq) this._faq.hidden = false;
    }

    afterPrint() {
      const snapshot = this._printSnapshot;
      if (!snapshot) return;
      snapshot.details.forEach((detail, index) => { detail.open = snapshot.open[index]; });
      this._articles.forEach((item, index) => { item.hidden = snapshot.hidden[index]; });
      if (this._faq) this._faq.hidden = snapshot.faqHidden;
      this._printSnapshot = null;
      this.updateExpandLabel();
      this.schedule();
    }

  }
  customElements.define(tag, NisaTermsPage);
})();


  } catch(e) { console.error(e); }
})();
})();
